<app-header></app-header>
<div class="container">
    <div class="row">
        <div class="col-10"><h2>Grupos</h2></div>
        <div *ngIf="registrar" class="col-2 d-flex" style="align-items: center; justify-content: end;">
            <label for="periodo" class="mx-2">Periodo:</label>
            <select [(ngModel)]="periodo" class="form-control" name="periodo" id="periodo" style="width: 3.5rem;" (change)="cambioPeriodo()">
                <option value="252" selected>252</option>
                <option value="251">251</option>
                <option value="242">242</option>
                <option value="241">241</option>
                <option value="232">232</option>
                <option value="231">231</option>
                <option value="222">222</option>
            </select>
        </div>
    </div>
    <div style="overflow: auto;">
        <table *ngIf="grupos.length" class="table table-bordered table-striped table-hover" datatable="ng" [dtOptions]="dtOptions">
            <thead>
            <tr style="background-color: #002061; color: #eee;">
                <th style="width:10%">SUBGRUPO</th>
                <th style="width:7%">GRUPO</th>
                <th style="width:7%">CARRERA</th>
                <th style="width:6%">DESCRIPCION</th>
                <th style="width:27%">TUTOR</th>
                <th>NO. DE SESIONES</th>
                <th style="width:15%">VER GRUPO</th>
                <th style="width:15%">VER SESIONES</th>
                <th *ngIf="registrar" style="width:100%">REGISTRAR</th>
                <th>MATRICULAS</th>
                <th>ALUMNOS</th>
            </tr>
            </thead>
            <tbody>
                <tr *ngFor="let grupo of grupos">
                    <td>{{ grupo.subgrupo }}</td>
                    <td>{{ grupo.grupo }}</td>
                    <td>{{ grupo.carrera }}</td>
                    <td>{{ grupo.descripcion }}</td>
                    <td>{{ grupo.tutor }}</td>
                    <td>{{ grupo.numero_sesiones }}</td>
                    <td title="Ver alumnos del grupo"><button class="btn btn-color1" (click)="verGrupo(grupo.subgrupo, grupo.tutor)">Ver grupo <fa-icon [icon]="icon1"></fa-icon></button></td>
                    <td title="Ver sesiones grupales anteriores"><button class="btn btn-color2" (click)="verSesionGrupal(grupo.subgrupo)">Ver sesiones <fa-icon [icon]="icon2"></fa-icon></button></td>
                    <td *ngIf="registrar" title="Registrar sesiones grupales"><button class="btn btn-color3" (click)="registroGrupal(grupo.subgrupo)">Registrar <fa-icon [icon]="icon3"></fa-icon></button></td>
                    <td>{{ grupo.matriculas }}</td>
                    <td>{{ grupo.alumnos }}</td>
                </tr>
            </tbody>
        </table>
        <h5 *ngIf="!grupos.length" style="color: rgb(102, 4, 4);">*No hay ningún grupo para mostrar</h5>
    </div>
</div>


<!-- <div id="comp-render" *ngIf="displayRegistroGrupal && !displayAlumnos">
    <button class="btn btn-color2" (click)="volverAGrupo()">Volver</button>
    
</div>

<div id="comp-render" *ngIf="displayAlumnos && !displayRegistroGrupal">
    <app-expediente></app-expediente>
</div> -->